import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { PAYMENT_PLAN_SEARCH } from "Application/RequestTypes";
import {
  DEBTOR_DETAIL,
  PAYMENT_PLAN_CREATE,
  PAYMENT_PLAN_DETAIL,
  USER_DETAIL,
  getUrl,
} from "Infrastructure/config/routesConfig";
import Button from "pages/components/FormFields/Button";
import SearchTable from "pages/components/Molecules/SearchTable";
import { Link, useNavigate } from "react-router-dom";
import {
  Add as AddIcon,
  Check as CheckIcon,
  Clear as ClearIcon,
} from "@mui/icons-material";
import { formatDateTime, formatPrice } from "pages/Utils/Formats";
import { PaymentPlan } from "Domain/PaymentPlan/Entity/PaymentPlan";
import PaymentPlanStatusChip from "pages/components/Status/PaymentPlanStatusChip";
import { useTranslation } from "react-i18next";
import { getCurrentUserData } from "Application/User/UserService";
import { FilterConfig } from "pages/components/Molecules/SearchFilter";

export default function PaymentPlanList() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  function createPaymentPlan() {
    navigate(getUrl(PAYMENT_PLAN_CREATE));
  }
  const currentUser = getCurrentUserData();
  const columns: GridColDef<PaymentPlan>[] = [
    {
      field: "publicId",
      flex: 1,
      renderCell: (params) => (
        <Link to={getUrl(PAYMENT_PLAN_DETAIL, { id: params.row.publicId })}>
          {params.row.publicId}
        </Link>
      ),
    },
    ...(!currentUser.isUserDebtor()
      ? [
          {
            field: "debtor",
            flex: 1,
            renderCell: (params: any) => (
              <Link to={getUrl(DEBTOR_DETAIL, { id: params.row.debtorId })}>
                {`${params.row.debtorProfile.firstName} ${params.row.debtorProfile.lastName}`}
              </Link>
            ),
          },
        ]
      : []),
    ...(!currentUser.isUserCreditor()
      ? [
          {
            field: "creditor",
            flex: 1,
            renderCell: (params: any) => {
              return currentUser.isUserInternal() ? (
                <Link
                  to={getUrl(USER_DETAIL, {
                    id: params.row.creditorData.publicId,
                  })}
                >
                  {params.row.creditorData.name}
                </Link>
              ) : (
                params.row.creditorData.name
              );
            },
          },
        ]
      : []),
    {
      field: "financedAmount",
      flex: 1,
      valueGetter: (value, row) => formatPrice(value),
    },
    {
      field: "dueAmount",
      flex: 1,
      valueGetter: (value, row) => formatPrice(value),
    },
    {
      field: "createdAt",
      flex: 1,
      type: "string",
      valueGetter: (value, row) => formatDateTime(row.createdAt),
    },
    ...(!getCurrentUserData().isUserDebtor()
      ? [
          {
            field: "secured",
            flex: 1,
            renderCell: (params: any) => {
              return (
                <Box
                  width={"100%"}
                  height={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  {params.row.secured ? (
                    <CheckIcon color="success" />
                  ) : (
                    <ClearIcon color="error" />
                  )}
                </Box>
              );
            },
          },
        ]
      : []),
    {
      field: "status",
      flex: 1,
      renderCell: (params) => (
        <PaymentPlanStatusChip
          status={params.row.status}
        />
      ),
    },
  ];
  return (
    <>
      {!getCurrentUserData().isUserDebtor() && (
        <Box display={"flex"} justifyContent={"end"} paddingBottom={1}>
            <Button
              color="success"
              onClick={createPaymentPlan}
              startIcon={<AddIcon />}
              label={t("CONTENT.new_payment_plan")}
            />
        </Box>
      )}

      <SearchTable<PaymentPlan>
        columns={columns}
        additionalFilters={{}}
        endpoint={PAYMENT_PLAN_SEARCH}
        filterConfig={getSearchFilters(t)}
      />
    </>
  );
}

function getSearchFilters(t: Function) {
  const paymentPlanStatuses = [
    "INIT",
    "PENDING",
    "FINISHED",
    // "APPROVED",
    "VALID",
    // "DECLINED",
    // "INVALID",
    // "CANCELED",
    // "PARTIALLY_VALID",
  ];

  return {
    status: paymentPlanStatuses.map((status: string) => ({
      label: t(`STATUS.LABEL.payment_plan.${status}`),
      value: status,
    })),
    secured: "bool",
  } as FilterConfig;
}
